import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import PlanBalanceTable from "./planBalance-table/PlanBalanceTable";

export const PlanBalanceCard = () => {
  return (
    <Card>
      <CardHeader title="Sisa Kuota"></CardHeader>
      <CardBody>
        <PlanBalanceTable />
      </CardBody>
    </Card>
  );
};
